module.exports = __webpack_public_path__ + "img/maison18.17827ab2.jpg";